/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray, oneOf as codecOneOf } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { OAuthProvider, OAuthToken, SetupOAuthResult } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function oauthProvider(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(OAuthProvider))),
    });
    const putOAuthTokenResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([OAuthToken, SetupOAuthResult]))),
    });
    const getOAuthTokenResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(OAuthToken)),
    });
    const callbackResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    return Object.freeze({
        /**
         * Get all OAuth providers connected to this instance.
         *
         * @returns All connected providers.
         */
        getAll: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_providers/`, getAllResponse.v, undefined);
            return result;
        },
        /**
         * Get or create an OAuth token for the specified provider.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider for which you want to get/create a token.
         * @returns The token.
         */
        putOAuthToken: async ({ providerId, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/oauth_providers/${providerId}/token`, putOAuthTokenResponse.v, undefined);
            return result;
        },
        /**
         * Get an OAuth token for the specified provider.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider for which you want to get a token.
         * @returns The token.
         */
        getOAuthToken: async ({ providerId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_providers/${providerId}/token`, getOAuthTokenResponse.v, undefined);
            return result;
        },
        /**
         * The method that is used by OAuth providers after they completed the login flow.
         *
         * For the precise meaning of the query parameters see RFC 6749.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The id of the OAuthProvider that completed the flow.
         * @param arg.state The state.
         * @param arg.code The code.
         * @param arg.error The error.
         * @param arg.errorDescription The description of the error.
         * @returns A response that is not in any defined format.
         */
        callback: async ({ providerId, state = undefined, code = undefined, error = undefined, errorDescription = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_providers/${providerId}/callback`, callbackResponse.v, undefined, {
                state,
                code,
                error,
                error_description: errorDescription,
            });
            return result;
        },
    });
}
